import { render, staticRenderFns } from "./wel.vue?vue&type=template&id=53b37492&scoped=true"
import script from "./wel.vue?vue&type=script&lang=js"
export * from "./wel.vue?vue&type=script&lang=js"
import style0 from "./wel.vue?vue&type=style&index=0&id=53b37492&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b37492",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b37492')) {
      api.createRecord('53b37492', component.options)
    } else {
      api.reload('53b37492', component.options)
    }
    module.hot.accept("./wel.vue?vue&type=template&id=53b37492&scoped=true", function () {
      api.rerender('53b37492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/wel.vue"
export default component.exports